import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FrameComponent2 from "../components/FrameComponent2";
import FrameComponent1 from "../components/FrameComponent1";
import styles from "./Tuto.module.css";

const Tuto = () => {
  const navigate = useNavigate();

  const onTutoContainerClick = useCallback(() => {
    navigate("/produits");
  }, [navigate]);

  return (
    <div className={styles.tuto} onClick={onTutoContainerClick}>
      <h1 className={styles.lesTutoriels}>Les tutoriels</h1>
      <h3 className={styles.trouvezIciNos}>
        Trouvez ici, nos tutoriels sur la robotique
      </h3>
      <section className={styles.tutoContainerWrapper}>
        <div className={styles.tutoContainer}>
          <FrameComponent2 />
          <FrameComponent1 />
        </div>
      </section>
      <div className={styles.ctaWrapper}>
        <div className={styles.cta}>
          <div className={styles.roboticsCompanyLogo} />
          <b className={styles.voirPlus}>Voir plus</b>
        </div>
      </div>
    </div>
  );
};

export default Tuto;
